export default __webpack_public_path__ + "static/media/radio.c706df22.svg";